import * as types from "../constants";
import moment from 'moment';

const initialState = {
    date: moment().format("YYYY"),
    chart: {}
};

export default function reducer(state = initialState, actions) {
  const { type, payload } = actions;

  switch(type) {
    case types.CLEAR_MUM:
    case types.DELETE_MUM_CHART:
      return {
        ...state,
        chart: {}
      }
    case types.GET_MUM_CHART_TITLES:
      return {
        ...state,
        chartTitles: payload
      }
    case types.GET_MUM_YEARS:
      return {
        ...state,
        chartYears: payload
      }
    case types.ADD_MUM_CHEMICAL:
    case types.ADD_MUM_LEVEL:
    case types.ADD_MUM_MEASUREMENT:
    case types.SELECT_MUM_CHART:
    case types.CREATE_MUM_CHART:
    case types.EDIT_MUM_CHART:
    case types.COPY_MUM_CHART:
    case types.SAVE_MUM_TABLE:
      return {
        ...state,
        chart: payload,
      }
    case types.UPDATE_MUM_TABLE:
      return {
        ...state,
        chart: {
          ...state.chart,
          table: payload
        }
      }
    case types.CHANGE_MUM_DATE:
      return {
        ...state,
        date: payload
      }
    case types.MUM_CLEAN_UP:
      return initialState;
    default:
      return state;
  }
}
